import { Alert, AlertTitle, Button, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { useStore } from '@hooks/useStore'
import { BILLING_CONSTANTS } from '@constants'

export const TrialCountdownBanner: React.FC = observer(() => {
  const { billing } = useStore()
  const navigate = useNavigate()

  if (!billing.isOnTrial) return null

  const daysRemaining = billing.trialDaysRemaining

  const getSeverity = (): 'error' | 'warning' | 'info' => {
    if (daysRemaining === null) return 'info'
    if (daysRemaining <= 3) return 'error'
    if (daysRemaining <= 7) return 'warning'
    return 'info'
  }

  const getTitle = (): string => {
    if (daysRemaining === null) return BILLING_CONSTANTS.MESSAGES.TRIAL_ENDING_SOON
    if (daysRemaining === 0) return BILLING_CONSTANTS.MESSAGES.TRIAL_ENDING_TODAY
    return BILLING_CONSTANTS.MESSAGES.TRIAL_DAYS_REMAINING(daysRemaining)
  }

  const getMessage = (): string => {
    if (daysRemaining !== null && daysRemaining > 7) {
      return BILLING_CONSTANTS.MESSAGES.TRIAL_INFO_LONG
    }
    return BILLING_CONSTANTS.MESSAGES.TRIAL_INFO_SHORT
  }

  return (
    <Alert
      severity={getSeverity()}
      sx={{ mb: 3 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => navigate('/instellingen?tab=subscription')}
        >
          {BILLING_CONSTANTS.MESSAGES.UPGRADE_CTA_SETTINGS}
        </Button>
      }
    >
      <AlertTitle>{getTitle()}</AlertTitle>
      <Typography variant="body2">{getMessage()}</Typography>
    </Alert>
  )
})
